import React, { Component } from 'react'
import { connect } from "react-redux";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
// app config
import AppConfig from 'Constants/AppConfig';
import DatePicker from "react-datepicker";
import moment from 'moment';
import {
	FormGroup,
	Label,	
} from 'reactstrap';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
    studentOCScoring,
    fetchOnScoringChart,
    deleteOCScoring,
    fetchOCScoring,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ProgressLoader from 'Components/Widgets/ProgressLoader';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";

import ViewReport from '../../../../golf/oncoursetest/onscoringreport/component/viewreport';
import AddItem from '../../../../golf/oncoursetest/nineeighthole/component/addform';
import EditItem from '../../../../golf/oncoursetest/nineeighthole/component/editform';

import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

class CourseScoring extends Component {
   
   constructor(props) {
      
      super(props);
      
      this.confirmationDialog = React.createRef();
         this.state = {
            student:this.props.data.student, 
            startdate:this.props.data.startdate, 
            enddate:this.props.data.enddate, 
            viewdiv1:true,
            viewdiv2:true, 
            viewdiv3:false, 
            adddiv:false,         
            loader:false,   
            selectdates:'',
            seldata:[],
            dacheckbox:false,
            allcourse:[],     
            adddiv:false,
            viewdiv:true,
            listdiv:false,
            editdiv:false,
            club:'',
            sepmore:1,
            formValues: [{ holepar : "", fwhit : "", distance : "", girhit : "", puttlength:"", noputt : "", penalties : "", score : "", process : "", penradio:"", proradio:"", disfwhit:""}],
        };

       
        this.onEditBack = this.onEditBack.bind(this);
        this.addEntry = this.addEntry.bind(this);
        this.viewList = this.viewList.bind(this); 

        this.onBackSection = this.onBackSection.bind(this); 
        this.ViewReport = this.ViewReport.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.addEntry = this.addEntry.bind(this);
   } 

   UNSAFE_componentWillMount() {
	   
	} 

  

    selectstart = (date) => {  
        this.setState({ startdate:date });           
    }

    selectend = (date) => {  
        this.setState({ enddate:date });           
    }

    handleSubmit(evt){
        evt.preventDefault();   
        var student=this.state.student;
        if(this.state.startdate==""){
            var stdate="";    
        }else{
            var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        }
        if(this.state.enddate==""){
            var eddate="";
        }else{
            var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        }
        
        this.setState({ 
            loader:true,
            viewdiv2:false,
        });

        this.props.studentOCScoring(student, stdate, eddate).then((data) => {   
            
            this.setState({ 
                loader:false,
                viewdiv2:true,
            });

        });
        
        
    } 

    ViewReport(){
        var seldate=this.state.seldata;
        var alldate=seldate.join(',');
        var student=this.state.student;
        var course=''; 
        this.setState({ 
            loader:true,           
        });

        this.props.fetchOnScoringChart(student, alldate, course).then((data) => {   
            var resdata=data;
            var course=[];
            var rescourse=resdata.courses;
            if(resdata.length!=0){
                {rescourse.map((teamval, idx) => (                     
                    course.push({
                        id:teamval.ccb_clubID,
                        name:teamval.course,
                    })                    
                ))}
            }

            this.setState({ 
                allcourse:course,
                loader:false, 
                viewdiv2:false,
                viewdiv3:true,              
            });
        });

    }   

    handleChange(id, event){

        if (event.target.checked) {
           var seldate=event.target.value;
           this.setState({ seldata: [...this.state.seldata, seldate] })
        }else{
            var array = [...this.state.seldata]; 
            var index = array.indexOf(event.target.value)
            if (index !== -1) {
                array.splice(index, 1);
                this.setState({seldata: array});
            }
        }


    }

    addEntry(){
        this.setState({ 
            adddiv:true,
            viewdiv2:false,
            listdiv:false,
       });
    }

    viewList(){
        var stdid=this.state.student;
        var start='';
        var end='';
        this.props.studentOCScoring(stdid, start, end).then((data) => {   
            
            this.setState({ 
                viewdiv:false,
                viewdiv2:false,
                listdiv:true
            });

        });
        
    }

    onBackSection() {
		this.setState({ 
            adddiv:false,
            listdiv:false,
            viewdiv3:false,
            viewdiv2:true,
       });
	}
    
    onEditBack() {
		this.setState({ 
            adddiv:false,
            editdiv:false,
            listdiv:true,
       });
	}  

    editAssessment(assmval){
        
        var id=assmval.gne_userID;
        var date=assmval.gne_date;
          
          this.props.fetchOCScoring(id, date).then((data) => {   
              var resdata=data.data;
              var troptobj=[]; 
              {resdata.map((teamval) => (   
  
                 troptobj.push({
                    holepar:teamval.gne_holepar,
                    fwhit: teamval.gne_holepar!=3?teamval.gne_fwhit:'',
                    distance : teamval.gne_distance,
                    girhit: teamval.gne_girhit,
                    puttlength:teamval.gne_lengthputt,
                    noputt: teamval.gne_noputt,
                    penalties:teamval.gne_penalties,
                    score:teamval.gne_score,
                    process:teamval.gne_process,
                    penradio:teamval.gne_penalties==0 ? 0 : 1, 
                    proradio:teamval.gne_process==0 ? 0 : 1,
                    disfwhit:teamval.gne_holepar==3? 1 : 0,
                 })
              ))} 
              
              this.setState({ 
                 seldate:resdata[0].gne_date, 
                 student:resdata[0].gne_userID,
                 club:resdata[0].gne_courseID,
                 formValues:troptobj,
                 sepmore:resdata.length
              });
  
              this.setState({ 
                  viewdiv:false,  
                  listdiv:false,              
                  adddiv:false,
                  editdiv:true,
              });
  
          });
      }
  
      deleteForm(assmval){
        this.id = assmval.gne_userID;
        this.date = assmval.gne_date;
        this.confirmationDialog.current.openDialog();
      }
  
     deleteDataPermanent(popupResponse){
        
           if (popupResponse) {
              this.props.deleteOCScoring(this.id, this.date);
              this.data = ""
           }
     }
   

    render() {
      const { match, studentlists, ocscoringlist, loading } = this.props;      
      const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
    };

    const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "action", label: "EDIT" },
            { name: "action1", label: "DELETE" },
        
    ];
    const tabledata=ocscoringlist.map((assmntval,idx) => {     
           const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval)}><EditOutlinedIcon/></IconButton>;     
           const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
            
            return {
              no:idx+1,
              name: assmntval.student,
              cdate: assmntval.cdate,
              action: ebtn,
              action1:dbtn,
            
            }
    }); 

       return (
          <div className="saas-dashboard">
             <div className="row" style={{marginBottom:"20px"}}>
                    <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                    <div className="col-lg-8"><h2 className="text-center">ON COURSE SCORING</h2></div>
                    <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={() => this.props.onClick1()}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
             </div>
             <div className="row">
                        
                    {this.state.viewdiv1 &&                             
                        <div className="col-sm-12 col-lg-6" style={{margin:"0 auto"}}>
                            <RctCollapsibleCard>                              
                                <form autoComplete="off" id="addform" onSubmit={(e)=>this.handleSubmit(e)}>              
                                    <div className="row">                                                    
                                        <div className="col-lg-5">
                                            <FormGroup >
                                                <DatePicker className="form-control" id="startdate" placeholderText="Start Date"  name="startdate" required autoComplete="off" 
                                                        selected={this.state.startdate}
                                                        onChange={this.selectstart}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown 
                                                    /> 
                                            </FormGroup>                                          
                                        </div>
                                        <div className="col-lg-5">
                                            <FormGroup >
                                                <DatePicker className="form-control" id="enddate" placeholderText="End Date"  name="enddate" required autoComplete="off" 
                                                        selected={this.state.enddate}
                                                        onChange={this.selectend}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                    /> 
                                            </FormGroup>                                          
                                        </div>
                                        <div className="form-group">                       
                                            <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Filter"/>                                            
                                        </div>              
                                    </div>
                                </form>  
                            </RctCollapsibleCard>                                                    
                        </div>
                    }
                </div>

                {this.state.viewdiv2 && 
                    <div className="col-sm-12 col-lg-6" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading="List" fullBlock>
                            <div className="col-md-12">
                            <div className="as"> 
                                <div className="float-left"><a onClick={this.addEntry} style={{color:"blue"}}><span class="icon-plus"></span> Add</a> <a style={{color:"orange", paddingLeft:"10px"}} onClick={this.viewList}><span class="icon-list"></span> List</a></div>
                                <button type="button" className="mr-3 mb-3 btn btn-outline-success float-right" onClick={this.ViewReport} >View Report</button>   
                            </div>   
                            </div>
                            <div className="table-responsive">
                                <Table>
                                    <TableHead>
                                        <TableRow hover>   
                                        <TableCell>No</TableCell>
                                            <TableCell>NAME</TableCell>
                                            <TableCell>DATE</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                    {ocscoringlist.map((element, i) => (
                                            
                                        <TableRow key={i}>
                                            <TableCell><input type="checkbox" name={'datecheckbox'} value={element.gne_date}  onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative"/></TableCell>
                                            <TableCell>{element.student}</TableCell>
                                            <TableCell>{element.cdate}</TableCell> 
                                        </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>   
                            </div>   
                        </RctCollapsibleCard>
                    </div>
                }

                {this.state.viewdiv3 && 
                  <ViewReport onClick={this.onBackSection} data={this.state}/>
                }

                {this.state.adddiv&&
                 <AddItem onClick={this.onBackSection} data={this.state}/>
                }

                {this.state.listdiv &&
                    <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading="ON COURSE SCORING LIST" fullBlock>
                            <MUIDataTable    
                                    title={<div><Button onClick={ ()=>this.onBackSection()} className="btn btn-outline-warning"> Back</Button></div>}                               
                                    data={tabledata}
                                    columns={columns}
                                    options={options} 
                            />   
                        </RctCollapsibleCard>
                    </div>
                }

                {this.state.editdiv && 
                  <EditItem onClick={this.onEditBack} data={this.state}/>              
                }

                <ConfirmationDialog
                ref={this.confirmationDialog}
                onConfirm={(res) => this.deleteDataPermanent(res)}
                data={'on course score'}
                />

                {this.state.loader &&
                    <div className="col-lg-12">
                        <ProgressLoader />
                    </div>
                }
                
          </div>
       )
    }
 }

const mapStateToProps = ({ mostlyused, ocscoring }) => {
	const { studentlists, loading } = mostlyused;
    const { ocscoringlist } = ocscoring;
	return { studentlists, ocscoringlist, loading };
}

export default connect(mapStateToProps, {   
    studentOCScoring,
    fetchOnScoringChart,
    deleteOCScoring,
    fetchOCScoring,
})(CourseScoring); 